import * as React from "react";
import { forwardRef } from "react";
const SvgArrowStraight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.6667 9.99967L10 3.33301L3.33334 9.99967L4.20834 10.8747L9.37501 5.70801V16.6663H10.625V5.70801L15.7917 10.8747L16.6667 9.99967Z", fill: "#473A2E" }));
const ForwardRef = forwardRef(SvgArrowStraight);
export { ForwardRef as ReactComponent };
